export default "__VITE_ASSET__HvencWSb__"